import React from 'react';
import ErrorDisplayUi from './ErrorDisplayUi';

// This is the spinner for when the user is syncing the project to github
const SyncToGithub = (props) => {
  const { displaySyncToGithubSpinner, displayWentWrongUi, setDisplayWentWrongUi } = props;

  return (
    <>
      <div
        style={displaySyncToGithubSpinner === false ? { display: 'none' } : null}
        id="cover-spin2"
      >
        <div
          style={{
            position: 'absolute',
            top: '35%',
            fontSize: '1.5vw',
            justifyContent: 'center',
            display: 'flex',
            width: '100%',
          }}
        >
          {' '}
          <span style={{ color: '#0c4d82' }}>
            Please wait while we are pushing your code to github. This might take a couple of
            minutes
          </span>
        </div>
      </div>

      <ErrorDisplayUi
        displayWentWrongUi={displayWentWrongUi}
        setDisplayWentWrongUi={setDisplayWentWrongUi}
      />
    </>
  );
};

export default SyncToGithub;
